import { MoneySchema } from "@redotech/redo-fulfillment-outbound-labels-common/util";
import { privacy } from "@redotech/schema-privacy";
import * as z from "zod";

const FulfillmentLineItemSchema_ = z
  .object({
    externalId: z.string().meta({ privacy: privacy.nonPii }),
    imageUrl: z.string().nullish().meta({ privacy: privacy.redact }),
    customAttributes: z
      .array(
        z
          .object({
            key: z.string().meta({ privacy: privacy.nonPii }),
            value: z.string().meta({ privacy: privacy.free_text }),
          })
          .meta({ privacy: privacy.structured }),
      )
      .meta({ privacy: privacy.structured }),
    quantity: z.number().meta({ privacy: privacy.nonPii }),
    currentQuantity: z.number().meta({ privacy: privacy.nonPii }),
    productId: z.string().nullish().meta({ privacy: privacy.nonPii }),
    variantId: z.string().nullish().meta({ privacy: privacy.nonPii }),
    lineItemId: z.string().meta({ privacy: privacy.nonPii }),
    title: z.string().meta({ privacy: privacy.nonPii }),
    variantTitle: z.string().meta({ privacy: privacy.nonPii }),
    productTitle: z.string().nullish().meta({ privacy: privacy.nonPii }),
    sku: z.string().nullish().meta({ privacy: privacy.nonPii }),
    bin: z.string().nullish().meta({ privacy: privacy.nonPii }),
    barcode: z.string().nullish().meta({ privacy: privacy.nonPii }),
    originalUnitPrice: MoneySchema.meta({ privacy: privacy.structured }),
    discountedUnitPrice: MoneySchema.meta({ privacy: privacy.structured }),
    totalPrice: MoneySchema.meta({ privacy: privacy.structured }),
    selectedOptions: z
      .array(
        z
          .object({
            name: z.string().meta({ privacy: privacy.nonPii }),
            value: z.string().meta({ privacy: privacy.nonPii }),
          })
          .meta({ privacy: privacy.structured }),
      )
      .nullish()
      .meta({ privacy: privacy.structured }),
    totalDiscountedPrice: MoneySchema.meta({ privacy: privacy.structured }),
    totalTax: MoneySchema.meta({ privacy: privacy.structured }),
  })
  .meta({ privacy: privacy.structured });
export const FulfillmentLineItemSchema: z.ZodType<FulfillmentLineItem> =
  FulfillmentLineItemSchema_;

export interface FulfillmentLineItem extends z.infer<
  typeof FulfillmentLineItemSchema_
> {}
export interface IFulfillmentLineItem extends z.ZodType<FulfillmentLineItem> {}
